import { type ExcalidrawFontFaceDescriptor } from "../Fonts";

import Light from "./TicketLight.woff2";

export const TicketLightFontFaces: ExcalidrawFontFaceDescriptor[] = [
  // Thin  ExtraLight  Light  Regular  Medium  SemiBold  Bold  ExtraBold
  { uri: Light },
];
